import React, { Component } from 'react';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { Button, Grid, IconButton, Link, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import './report.less';
import PrintIcon from '@material-ui/icons/Print';

export default class ReportButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static get propTypes() {
    return {
      children: PropTypes.any,
      handleClickOpen: PropTypes.func,
      handleSubmit: PropTypes.func,
      resetPage: PropTypes.func,
      handlePrintClick: PropTypes.func,
      data: [],
      fileName: PropTypes.string,
      hideAdvanceFilter: PropTypes.bool,
      hideAdvanceLink: PropTypes.bool,
      hideButtons: PropTypes.bool
    };
  }

  render() {
    return (
      <Grid item xs={12} lg={2}>
        {this.props.hideAdvanceLink !== true && <Grid item xs={12} style={{ marginTop: '21px' }}>
          <Link
            onClick={this.props.handleClickOpen}
            style={{ cursor: 'pointer' }}
          >
            Advanced Filters
          </Link>
        </Grid>}
        <Grid item xs={12}>
          <div style={{ display: 'flex', float: 'right' }}>
          {this.props.hideAdvanceFilter !== true && <Button
              color="primary"
              disabled={this.props.disableRunReport || false}
              type="submit"
              onClick={this.props.handleSubmit}
              variant="contained"
              style={{
                width: '72px',
                marginTop: '25px',
                height: '36px',
                backgroundColor: '#05375E',
                marginBottom: '6px',
                fontSize: '0.6rem'
              }}
              // className={(this.props.disableRunReport || false) === true ? 'button-disabled' : 'button-enabled'}
            >
              Run Report
              </Button>}
            <>
              {this.props.hideButtons !== true && this.props.data !== null &&
                this.props.data.length > 0 &&
                <div style={{ marginTop: '2.2rem' }}>
                  <Tooltip title="Export Excel">
                    <IconButton
                    disabled={this.props.disableRunReport || false}
                     size="small" 
                     onClick={() => this.props.downloadFile('application/vnd.ms-excel', 'Excel')}>
                      <div style={{ fontSize: '1.5rem', color: '#05375E' }}>
                        <AssignmentIcon />
                      </div>
                    </IconButton>
                  </Tooltip>
                </div>
              }
              {this.props.hideButtons !== true && this.props.data !== null &&
                this.props.data.length > 0 &&
                <div style={{ marginTop: '2.2rem' }}>
                  <Tooltip title="Export Pdf">
                    <IconButton size="small"
                    disabled={this.props.disableRunReport || false}
                      onClick={() => this.props.downloadFile('application/pdf', 'Pdf', false)} >
                      <div style={{ fontSize: '1.5rem', color: '#05375E' }}>
                        <PictureAsPdfIcon />
                      </div>
                    </IconButton>
                  </Tooltip>
                </div>
              }
              {this.props.hideButtons !== true && this.props.data !== null &&
                this.props.data.length > 0 &&
                <div style={{ marginTop: '2.2rem' }}>
                  <Tooltip title="Print">
                    <IconButton
                      size="small"
                      disabled={this.props.disableRunReport || false}
                      // onClick={this.props.handlePrintClick}
                      onClick={() => this.props.downloadFile('application/pdf', 'Pdf', true)}
                    >
                      <div style={{ fontSize: '1.5rem', color: '#05375E' }}>
                        <PrintIcon />
                      </div>
                    </IconButton>
                  </Tooltip>
                </div>
              }
              {this.props.hideAdvanceFilter !== true && <div style={{ marginTop: '2.2rem' }}>
                <Tooltip title="Reset Filters">
                  <IconButton size="small"
                  disabled={this.props.disableRunReport || false}
                  onClick={this.props.resetPage}>
                    <div style={{ fontSize: '1.5rem', color: '#05375E' }}>
                      <RotateLeftIcon />
                    </div>
                  </IconButton>
                </Tooltip>
              </div>}
            </>
          </div>
        </Grid>
      </Grid>
    );
  }
}
